import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from "vue";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'editLayout',
    setup: function (__props) {
        var menuContentContainerRef = ref(null);
        window.menuContentContainerRef = menuContentContainerRef;
        api.requestWithSmallLoad
            .get("/postlist")
            .then(function (res) {
            var resp = res;
            window.PostRefUsePostList = resp.data;
        })
            .catch(function (error) {
            var msg = error.response.msg;
            window.$notifyError("获取文章列表失败", msg);
        });
        return function (_ctx, _cache) {
            var _component_head_right_tool_bar = _resolveComponent("head-right-tool-bar");
            var _component_router_view = _resolveComponent("router-view");
            var _component_n_layout = _resolveComponent("n-layout");
            return (_openBlock(), _createBlock(_component_n_layout, { class: "content-layout" }, {
                default: _withCtx(function () { return [
                    _createVNode(_component_head_right_tool_bar),
                    _createElementVNode("div", {
                        class: "content-container",
                        ref_key: "menuContentContainerRef",
                        ref: menuContentContainerRef
                    }, [
                        _createVNode(_component_router_view)
                    ], 512)
                ]; }),
                _: 1
            }));
        };
    }
});
